export default "__VITE_ASSET__nqV$k1l5__"